(function () {
  var root = document.documentElement;

  function flagDeviceMode() {
    try {
      var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      if (reduceMotion) {
        root.classList.add("bm-reduce-motion");
      }
    } catch (error) {}
  }

  function markImageFailed(img) {
    img.classList.add("bm-image-failed");
    img.setAttribute("aria-hidden", "true");

    var holder = img.closest(".hero-bean, .caffinity-trail-card, .ticker-item");
    if (holder) {
      holder.classList.add("bm-image-failed");
      holder.setAttribute("aria-hidden", "true");
    }
  }

  function markImageReady(img) {
    img.classList.add("bm-image-ready");

    var holder = img.closest(".hero-bean, .hero-packet, .robusta-detail-visual, .brew-card-image, .ticker-item");
    if (holder) {
      holder.classList.add("bm-image-ready");
    }
  }

  function inferImageAlt(img) {
    var existing = (img.getAttribute("alt") || "").trim();
    if (existing) return;
    if (img.closest('[aria-hidden="true"], .hero-bean, .ticker-item, .caffinity-trail-card')) return;

    var text = [
      img.currentSrc || img.src || "",
      img.className || "",
      img.getAttribute("data-bm-fallback") || ""
    ].join(" ").toLowerCase();

    var alt = "";
    if (text.indexOf("fssai") !== -1) alt = "FSSAI license logo";
    else if (text.indexOf("hero-mule-logo") !== -1 || text.indexOf("nav-bean") !== -1 || text.indexOf("logo") !== -1) alt = "Brown Mule logo";
    else if (text.indexOf("arabica-ground") !== -1) alt = "Brown Mule Arabica Powder coffee pack";
    else if (text.indexOf("arabica-whole") !== -1 || text.indexOf("arabica-pack") !== -1) alt = "Brown Mule Arabica Whole Bean coffee pack";
    else if (text.indexOf("robusta-ground") !== -1) alt = "Brown Mule Robusta Powder coffee pack";
    else if (text.indexOf("robusta-whole") !== -1 || text.indexOf("robusta-pack") !== -1) alt = "Brown Mule Robusta Whole Bean coffee pack";
    else if (text.indexOf("coffee-bean") !== -1) alt = "Coffee bean artwork";

    if (alt) img.setAttribute("alt", alt);
  }
  function tuneImage(img) {
    if (!img || img.dataset.bmStability === "1") return;
    img.dataset.bmStability = "1";
    img.draggable = false;
    inferImageAlt(img);

    try {
      img.decoding = "async";
      if (img.closest(".hero-bean, .ticker, .special-collection, .meet-mule")) {
        img.loading = "lazy";
        img.fetchPriority = "low";
      } else {
        img.loading = img.loading || "eager";
      }
    } catch (error) {}

    img.addEventListener("error", function () {
      markImageFailed(img);
    }, { once: true });

    if (img.complete) {
      if (img.naturalWidth > 0) {
        markImageReady(img);
      } else {
        markImageFailed(img);
      }
      return;
    }

    img.addEventListener("load", function () {
      markImageReady(img);
    }, { once: true });

    if (typeof img.decode === "function") {
      img.decode().then(function () {
        markImageReady(img);
      }).catch(function () {
        if (img.complete && img.naturalWidth === 0) markImageFailed(img);
      });
    }
  }

  function tuneImages(scope) {
    var rootNode = scope || document;
    if (rootNode.nodeType === 1 && rootNode.matches && rootNode.matches("img")) {
      tuneImage(rootNode);
    }

    var images = rootNode.querySelectorAll ? rootNode.querySelectorAll("img") : [];
    images.forEach(tuneImage);
  }

  function currentPath() {
    var hashPath = window.location.hash && window.location.hash.replace(/^#\/?/, "/").split("?")[0];
    return hashPath && hashPath !== "/" ? hashPath : window.location.pathname;
  }

  function isProductPath(path) {
    return /^\/products?\//.test(path || "");
  }

  function forceTop() {
    try {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
    } catch (error) {}
  }

  var topResetToken = 0;
  var lastProductTopResetPath = "";

  function armProductTopLock() {
    var path = currentPath();
    if (!isProductPath(path)) return;
    if (path === lastProductTopResetPath) {
      updateProductPageClass();
      return;
    }
    lastProductTopResetPath = path;

    var token = ++topResetToken;
    var cancelled = false;
    var cleanupTimer = 0;
    var userEvents = ["wheel", "scroll", "touchstart", "touchmove", "pointerdown", "keydown"];

    function cleanup() {
      root.classList.remove("bm-route-lock-top");
      userEvents.forEach(function (name) {
        window.removeEventListener(name, cancel, true);
      });
      if (cleanupTimer) window.clearTimeout(cleanupTimer);
    }

    function cancel() {
      cancelled = true;
      cleanup();
    }

    function resetIfAllowed() {
      if (cancelled || token !== topResetToken || !isProductPath(currentPath())) return;
      forceTop();
    }

    updateProductPageClass();
    root.classList.add("bm-route-lock-top");
    userEvents.forEach(function (name) {
      window.addEventListener(name, cancel, { capture: true, passive: true, once: true });
    });

    resetIfAllowed();
    window.requestAnimationFrame(resetIfAllowed);
    cleanupTimer = window.setTimeout(cleanup, 180);
  }

  function installProductTopLock() {
    try {
      if ("scrollRestoration" in window.history) {
        window.history.scrollRestoration = "manual";
      }
    } catch (error) {}

    document.addEventListener("click", function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var link = event.target && event.target.closest ? event.target.closest("a[href]") : null;
      if (!link || link.target || link.hasAttribute("download")) return;

      var url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }

      var hashPath = url.hash && url.hash.replace(/^#\/?/, "/").split("?")[0];
      var path = hashPath && hashPath !== "/" ? hashPath : url.pathname;
      if (url.origin === window.location.origin && isProductPath(path)) {
        armProductTopLock();
      }
    }, true);

    ["pushState", "replaceState"].forEach(function (method) {
      var original = window.history[method];
      if (typeof original !== "function" || original.__bmTopLockPatched) return;

      var patched = function () {
        var result = original.apply(this, arguments);
        updateProductPageClass();
        if (isProductPath(currentPath())) armProductTopLock();
        return result;
      };

      patched.__bmTopLockPatched = true;
      window.history[method] = patched;
    });

    ["popstate", "hashchange", "pageshow", "load"].forEach(function (name) {
      window.addEventListener(name, function () {
        updateProductPageClass();
        if (isProductPath(currentPath())) armProductTopLock();
      });
    });

    if (isProductPath(currentPath())) armProductTopLock();
  }

  function installMobileHeroPacketScroll() {
    var update = function () {
      var hero = document.querySelector(".hero");
      if (!hero) return;

      var isMobile = window.matchMedia && window.matchMedia("(max-width: 768px)").matches;
      if (!isMobile) {
        hero.style.removeProperty("--hero-mobile-packet-scroll");
        return;
      }

      var rect = hero.getBoundingClientRect();
      var progress = Math.min(Math.max(-rect.top / (rect.height * 0.42), 0), 1);
      hero.style.setProperty("--hero-mobile-packet-scroll", Math.round(progress * 560) + "px");
    };

    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
  }

  function updateProductPageClass() {
    var productPage = isProductPath(currentPath());
    root.classList.toggle("bm-product-page", productPage);
    if (!productPage) lastProductTopResetPath = "";
  }

  function cleanRoastText(text) {
    return (text || "")
      .replace(/\s*[|•·-]\s*Roast\s*\d+.*/i, "")
      .replace(/\s*Roast\s*\d+.*/i, "")
      .trim();
  }

  function removeRoastLevels(scope) {
    var rootNode = scope && scope.querySelectorAll ? scope : document;
    var candidates = [];

    if (rootNode.matches && rootNode.matches(".finder-match-details article, .finder-answer-card article, .robusta-detail-rating, .robusta-detail-specs div, .robusta-detail-flavors span")) {
      candidates.push(rootNode);
    }

    rootNode.querySelectorAll && rootNode.querySelectorAll(".finder-match-details article, .finder-answer-card article, .robusta-detail-rating, .robusta-detail-specs div, .robusta-detail-flavors span").forEach(function (node) {
      candidates.push(node);
    });

    candidates.forEach(function (node) {
      if (/\bRoast\b/i.test(node.textContent || "")) node.remove();
    });

    rootNode.querySelectorAll && rootNode.querySelectorAll(".finder-match-copy em").forEach(function (em) {
      if (/\bRoast\b/i.test(em.textContent || "")) {
        em.textContent = cleanRoastText(em.textContent);
      }
    });

    rootNode.querySelectorAll && rootNode.querySelectorAll(".robusta-detail-description").forEach(function (desc) {
      desc.textContent = (desc.textContent || "")
        .replace(/,\s*finished with a balanced roast\s*\d*\s*profile for a rich everyday cup\./i, " for a rich everyday cup.")
        .replace(/Its balanced roast profile creates/i, "It creates")
        .replace(/Crafted with a balanced roast\s*\d*\s*profile,\s*/i, "Crafted for everyday brewing, ");
    });
  }

  function buildPepperBeanIcon() {
    return [
      '<svg class="bm-pepper-bean-icon" viewBox="0 0 64 64" aria-hidden="true" focusable="false" style="width:30px;height:30px;fill:currentColor;stroke:none;background:transparent;overflow:visible">',
      '<path fill="currentColor" d="M18.5 32.7C19.6 19.2 29.4 7.1 41.3 6.1c11.8-1 22 10.6 21 28.8-.1 2.7-.4 5.1-.8 7.2-8.7 3.2-20.3 2.3-27.8-3.8-5-4.1-8.8-6-15.2-5.6Z"/>',
      '<path fill="#fffaf4" d="M41.1 9.2c-10.3 7.1-11 18-4.4 30.3 1.6 3.1 3.3 6 4.4 8.3-5.8-3.8-10.7-15-11.9-24.8-.8-6.2 2-11 11.9-13.8Z"/>',
      '<path d="M24.5 17.6c-3.5 3.2-5.8 6.8-7.1 10.8" fill="none" stroke="#fffaf4" stroke-linecap="round" stroke-width="3.8"/>',
      '<path d="M45.4 13.8c7.2 3.8 12 11.7 14.4 23.7" fill="none" stroke="#fffaf4" stroke-linecap="round" stroke-width="3.8"/>',
      '<path fill="currentColor" d="M5.2 48.2c10.8-11.9 24.8-14.9 38.4-5.1 8.4 6 16.1 4.7 21.6-4.8-4.3 13.2-17.5 20.8-31.8 15.7-11.1-3.9-19.8-9-28.2-5.8Z"/>',
      '<circle cx="19.2" cy="50.3" r="3.8" fill="currentColor"/>',
      '<circle cx="30.5" cy="48.3" r="3.9" fill="currentColor"/>',
      '<circle cx="43.2" cy="52.5" r="3.8" fill="currentColor"/>',
      '<circle cx="24.8" cy="59.6" r="3.7" fill="currentColor"/>',
      '<circle cx="36.5" cy="60.9" r="3.8" fill="currentColor"/>',
      '<circle cx="50.8" cy="59.2" r="3.7" fill="currentColor"/>',
      '</svg>'
    ].join("");
  }

  function replaceRobustaGroundIcon(scope) {
    var rootNode = scope && scope.querySelectorAll ? scope : document;
    var cards = [];

    if (rootNode.matches && rootNode.matches(".lovable-brew-card")) {
      cards.push(rootNode);
    }

    rootNode.querySelectorAll && rootNode.querySelectorAll(".lovable-brew-card").forEach(function (card) {
      cards.push(card);
    });

    cards.forEach(function (card) {
      var heading = card.querySelector("h3");
      if (!heading || heading.textContent.trim().toUpperCase() !== "ROBUSTA GROUND") return;

      var target = card.querySelector(".lovable-brew-icons span:nth-child(2)");
      if (!target || target.dataset.bmPepperBeanIcon === "1") return;

      target.dataset.bmPepperBeanIcon = "1";
      target.innerHTML = buildPepperBeanIcon();
    });
  }

  function startObserver() {
    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            tuneImages(node);
            replaceRobustaGroundIcon(node);
            removeRoastLevels(node);
          }
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function runSoon(callback) {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(callback, { timeout: 900 });
    } else {
      window.setTimeout(callback, 80);
    }
  }

  flagDeviceMode();
  updateProductPageClass();
  installProductTopLock();
  installMobileHeroPacketScroll();

  function enhanceDom() {
    tuneImages(document);
    startObserver();
    runSoon(function () {
      replaceRobustaGroundIcon(document);
      removeRoastLevels(document);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      enhanceDom();
    }, { once: true });
  } else {
    enhanceDom();
  }
})();
